/* eslint-disable no-undef */
import { TweenLite } from 'gsap';

const parentClicked = e => {
  // make sure you have the li
  const listItem = e.target.closest('li');

  // get sub nav
  const subNav = listItem.querySelector('.sub-menu-wrap');
  if (subNav) {
    subNav.classList.add('isActive');
    TweenLite.to(subNav, 0.3, { x: '0%', zIndex: 100 });
  }
};

const closeSubNav = e => {
  const subNav = e.target.closest('.sub-menu-wrap');
  subNav.classList.remove('isActive');
  TweenLite.to(subNav, 0.3, { x: '-100%' });
};

document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.getElementById('mobileNav');
  const toggle = document.getElementById('primaryNav-toggle');
  const parentNavItems = document.getElementsByClassName('menu-item-has-children');
  const subMenuCloseButtons = document.getElementsByClassName('sub-menu-close');
  let open = false;
  let count = 0;
  const openText = document.getElementById('primaryNav-toggle-openText');
  const closeText = document.getElementById('primaryNav-toggle-closeText');

  if (!toggle) {
    return;
  }

  if (mobileNav === null) {
    return;
  }

  toggle.onclick = () => {
    open = !open;

    toggle.classList.toggle('active');
    document.getElementsByTagName('html')[0].classList.toggle('no-scroll');
    document.getElementsByTagName('html')[0].classList.toggle('mobile-open');

    if (count > 0) {
      toggle.classList.toggle('closed');
    }

    count += 1;

    if (closeText !== null) {
      TweenLite.to(closeText, 0, { autoAlpha: 1, y: '-100%' });
    }

    if (open) {
      TweenLite.to(mobileNav, 0.3, { autoAlpha: 1, display: 'block' });
      if (openText !== null && closeText !== null) {
        TweenLite.to(openText, 0.3, { autoAlpha: 0, y: '100%', display: 'none' });
        TweenLite.to(closeText, 0.3, { autoAlpha: 1, y: '0%', display: 'block' });
      }
    } else {
      TweenLite.to(mobileNav, 0.3, { autoAlpha: 0, display: 'none' });
      if (openText !== null && closeText !== null) {
        TweenLite.to(closeText, 0.3, { autoAlpha: 0, y: '-100%', display: 'none' });
        TweenLite.to(openText, 0.3, { autoAlpha: 1, y: '0%', display: 'block' });
      }
    }
  };

  for (let i = 0; i < parentNavItems.length; i += 1) {
    parentNavItems[i].addEventListener('click', parentClicked);
  }

  for (let j = 0; j < subMenuCloseButtons.length; j += 1) {
    subMenuCloseButtons[j].addEventListener('click', closeSubNav);
  }
});
